import Vue from 'vue'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import '@/assets/scss/plugins/vue-toastification.scss'

Vue.use(Toast, {
  transition: 'Vue-Toastification__fade',
  maxToasts: 5,
  newestOnTop: true,
  position: 'bottom-center',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: false,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: false,
  icon: false,
  toastClassName: 'icu-toast',
  bodyClassName: 'icu-toast-body',
  containerClassName: 'icu-toast-container'
})
